import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, EscolasProximas } from './types';

export const INITIAL_STATE: EscolasProximas = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EscolasProximas {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ESCOLAS_PROXIMAS_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.ESCOLAS_PROXIMAS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ESCOLAS_PROXIMAS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			default:
		}
		return draft;
	});
}
